import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import { Outlet } from 'react-router-dom'
import OfferSlider from '../OfferSlider/OfferSlider'
import CategorySlider from '../CategorySlider/CategorySlider'
import Loading from '../Loading/Loading'
import { ToastContainer } from 'react-toastify';
import Footer from '../Footer/Footer'
export default function Layout({token,logOut}) {


   

  return <div className='lay'>
  
  <Navbar token={token} logOut={logOut}/>
  <Outlet />
  <div className="footer "><Footer /></div>
  </div>
}
